export const updatePassword = {
  'Update password': 'Atualizar senha',
  'Create a new password to complete <2>access to your account.</2>':
    'Crie uma nova senha para concluir o <2>acesso à sua conta.</2>',
  'You only have {{time}} to register your new password.':
    'Você tem apenas {{time}} para cadastrar sua nova senha.',

  'You must provide a password following all the requirements bellow':
    'Você deve informar uma senha que siga todos os requisitos abaixo',
  'The passwords are not the same': 'As senhas não são iguais',
  'You must provide a password': 'Você deve informar uma senha',

  'It must contain at least 8 characters':
    'Deve conter pelo menos 8 caracteres',
  'It must contain at least one lower case letter':
    'Deve conter pelo menos uma letra minúscula',
  'It must contain at least one upper case letter':
    'Deve conter pelo menos uma letra maiúscula',
  'It must contain at least one number': 'Deve conter pelo menos um número',
  'It must contain at least one special character':
    'Deve conter pelo menos um caractere especial',

  'Success!': 'Sucesso!',
  'Your password was updated successfully! Now you can login into your customer area with the new password created':
    'Sua senha foi atualizada com sucesso! Agora você pode logar na sua área do cliente com sua nova senha criada.',
  'Go home': 'Ir para o início',
  Login: 'Fazer meu login',

  'Password reset unavailable!': 'Redefinição de senha indisponível!',
  'This password reset is unavailable. Please, request a new code to continue':
    'Esta redefinição de senha está indisponível. Por favor, solicite um novo código',

  'Reset expired password!': 'Redefinição de senha expirada!',
  'This password reset is expired. Please, request a new code to continue':
    'O tempo para alterar sua senha expirou. Solicite um novo código para continuar',
};
